import { useState } from 'react'

import { Item } from './item'
import { data } from './data'
import { Backdrop, List, ListContainer, StyledSection } from './styled'
import { Container } from 'components/container'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'

export const Laws = () => {
  const isSmall = useMedia([breakpoints.ltLarge], [true], false)
  const [reversedIndex, setReversedIndex] = useState({
    current: -1,
    previous: -1,
  })

  return (
    <StyledSection heading="Что говорят законы?">
      <Container $mode={isSmall ? 'text' : 'default'}>
        <ListContainer>
          <Backdrop
            $isVisible={reversedIndex.current >= 0}
            onClick={() =>
              setReversedIndex((v) => ({ current: -1, previous: v.current }))
            }
          />
          <List>
            {data.map((item, index) => (
              <Item
                key={item.countryName}
                isPrevious={reversedIndex.previous === index}
                isReversed={reversedIndex.current === index}
                onReverse={() =>
                  reversedIndex.current === index
                    ? setReversedIndex((v) => ({
                        current: -1,
                        previous: v.current,
                      }))
                    : setReversedIndex({ current: index, previous: -1 })
                }
                onClose={() =>
                  setReversedIndex((v) => ({
                    current: -1,
                    previous: v.current,
                  }))
                }
                mapSrc={item.mapSrc}
                countryName={item.countryName}
                description={item.description}
              />
            ))}
          </List>
        </ListContainer>
      </Container>
    </StyledSection>
  )
}
